import alert from './alert'
import loader from './loader'
import reasonModal from './reasonModal'

export default {
  strict: false,
  namespaced: true,
  state: Object.assign(
    alert.state,
    loader.state,
    reasonModal.state,
  ),
  mutations: Object.assign(
    alert.mutations,
    loader.mutations,
    reasonModal.mutations,
  )
}



// WEBPACK FOOTER //
// ./src/store/global/index.js